import { Component, Input, OnInit } from '@angular/core';
import { SPORTS } from '@core/constants';
import { LocalStorage } from '@core/localstorage';
import { NbThemeService } from '@nebular/theme';

interface RankingProvider {
    name: string;
    logo: string;
    ctaText: string;
    route: string;
    translationKey: string;
}

const rankingProviders: { [key: string]: RankingProvider } = {
    DUPR: {
        name: 'DUPR',
        logo: '/assets/images/dupr-logo-cta.png',
        ctaText: 'Ver meu DUPR',
        route: '/rating/dupr/dupr-rating',
        translationKey: 'WTN.CTA.BUTTON'
    },
    WTN: {
        name: 'WTN',
        logo: '/assets/images/wtn-logo-cta.png',
        ctaText: 'Ver meu WTN',
        route: '/rating/wtn/wtn-rating',
        translationKey: 'WTN.CTA.BUTTON'
    },
    UTR: {
        name: 'UTR',
        logo: '/assets/images/utr-logo-cta.png',
        ctaText: 'Ver meu UTR',
        route: '/rating/utr/utr-rating',
        translationKey: 'UTR.CTA.BUTTON'
    }
};

/**
 * RatingCtaComponent - Componente dinâmico de CTA para diferentes provedores de ranking
 * 
 * Este componente cria um botão CTA (Call To Action) que redireciona para a página
 * interna de ranking com o path correto baseado no provedor selecionado.
 * 
 * @example
 * ```html
 * <!-- Para WTN (padrão) -->
 * <app-rating-cta></app-rating-cta>
 * 
 * <!-- Para DUPR -->
 * <app-rating-cta provider="DUPR"></app-rating-cta>
 * 
 * <!-- Para UTR -->
 * <app-rating-cta provider="UTR"></app-rating-cta>
 * ```
 * 
 * @Input provider - Nome do provedor de ranking: 'WTN' | 'DUPR' | 'UTR' (padrão: 'WTN')
 * 
 * Configurações disponíveis:
 * - WTN: /wtn/wtn-rating
 * - DUPR: /dupr/dupr-rating
 * - UTR: /utr/utr-rating
 */
@Component({
    selector: 'app-rating-cta',
    templateUrl: './rating-cta.component.html',
    styleUrls: ['./rating-cta.component.scss'],
})
export class RatingCtaComponent implements OnInit {
    @Input() provider: string = 'DUPR';

    buttonSize = 'medium';
    
    constructor(public themeService: NbThemeService, private localStorage: LocalStorage) {
        this.themeService.onMediaQueryChange().subscribe(([_, currentBreakpoint]) => {
            if (currentBreakpoint.width < 768) {
                this.buttonSize = 'small';
            } else {
                this.buttonSize = 'medium';
            }
        });
    }

    get rankingData(): RankingProvider {
        return rankingProviders[this.provider] || rankingProviders['WTN'];
    }

    ngOnInit(): void {
        this.setProviderFromSport();
    }

    private setProviderFromSport() {
        const sport = this.localStorage.getSport();

        switch (sport) {
            case SPORTS.TENNIS:
                this.provider = 'WTN';
                break;
            case SPORTS.PICKLEBALL:
                this.provider = 'DUPR';
                break;
            default:
                this.provider = 'WTN';
        }
    }
}
